import React, { useMemo, useState } from 'react';

import { SideNavContext } from './SideNavContext';

type SideNavProviderProps = {
	children: React.ReactNode;
};

export const SideNavProvider = ({ children }: SideNavProviderProps): React.JSX.Element => {
	const [isSideNavOpen, setSideNavOpen] = useState(false);
	const value = useMemo(() => ({ isSideNavOpen, setSideNavOpen }), [isSideNavOpen, setSideNavOpen]);

	return <SideNavContext.Provider value={value}>{children}</SideNavContext.Provider>;
};
